import script from "./Snappy-BaseData.vue?vue&type=script&setup=true&lang=js"
export * from "./Snappy-BaseData.vue?vue&type=script&setup=true&lang=js"

import "./Snappy-BaseData.vue?vue&type=style&index=0&id=30d25ff2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d25ff2"]])

export default __exports__